import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
export { configure } from './api';
export const routes = [{
  path: '/stock-selection',
  component: <History />
}, {
  path: '/stock-selection/settlement',
  component: <SettlementQueue />
}, {
  path: '/stock-selection/create',
  component: <PredictionInput />
}, {
  path: '/stock-selection/prompts',
  component: <PublicPrompt />
}, {
  path: '/stock-selection/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/stock-selection/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'stock-selection',
  label: 'Stock Selection',
  icon: 'ri-stock-line',
  link: '/stock-selection'
};
export const publicNavigation = { label: 'AI Picked', link: '/stock-selection' };
export function getNavigation({ admin, paid }) {
  return { ...navigation, subItems: [
    {id:'stock-selection-history',label:'History',link:'/stock-selection',parentId:navigation.id},
    ...((admin || paid) ? [
      {id:'stock-selection-input',label:'Prediction Input',link:'/stock-selection/create',parentId:navigation.id},
      {id:'stock-selection-settlement',label:'Settlement',link:'/stock-selection/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
